import { inject } from 'vue';
import { APP_PROGRESS_LOADER_KEY } from '../plugin';

export const useAppProgressLoader = () => {
	const loader = inject(APP_PROGRESS_LOADER_KEY);

	if (!loader) {
		throw new Error('App progress loader is not installed.');
	}

	return loader;
};
